import * as React from "react"
import type { SVGProps } from "react"
const SvgDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 16.15a1 1 0 0 1-.37-.07 1 1 0 0 1-.33-.2l-3.6-3.6a1 1 0 0 1-.29-.7q.01-.4.29-.7.3-.3.71-.32a1 1 0 0 1 .72.29L11 12.72V5.57q0-.42.29-.71a1 1 0 0 1 .71-.29q.42 0 .71.29.3.29.29.71v7.15l1.88-1.87a1 1 0 0 1 .7-.3 1 1 0 0 1 1 1.02 1 1 0 0 1-.28.7l-3.6 3.6q-.14.15-.32.21a1 1 0 0 1-.38.07m-6 4.42q-.82 0-1.41-.59A2 2 0 0 1 4 18.57v-2q0-.42.29-.71a1 1 0 0 1 .71-.29q.42 0 .71.29.3.29.29.71v2h12v-2q0-.42.29-.71a1 1 0 0 1 .71-.29q.42 0 .71.29.3.29.29.71v2q0 .82-.59 1.41a2 2 0 0 1-1.41.59z" />
  </svg>
)
export default SvgDownload
